// Auto generated file, do not manually modify!
// com.hotpads.capps.enums.ClearableAnswerField

export enum ClearableAnswerField {
  BACKGROUND_REPORT_COMMENT = 'BACKGROUND_REPORT_COMMENT',
  CREDIT_REPORT_COMMENT = 'CREDIT_REPORT_COMMENT',
  CURRENT_RESIDENCE = 'CURRENT_RESIDENCE',
  FIRST_NAME = 'FIRST_NAME',
  IS_MOVE_IN_DATE_FLEXIBLE = 'IS_MOVE_IN_DATE_FLEXIBLE',
  IS_SMOKER = 'IS_SMOKER',
  LAST_NAME = 'LAST_NAME',
  MIDDLE_NAME = 'MIDDLE_NAME',
  MOVE_IN_DATE = 'MOVE_IN_DATE',
  OCCUPANTS = 'OCCUPANTS',
  PETS = 'PETS',
  PHONE = 'PHONE',
  REASON_FOR_MOVING = 'REASON_FOR_MOVING',
}

export const ClearableAnswerField_values = [
  ClearableAnswerField.BACKGROUND_REPORT_COMMENT,
  ClearableAnswerField.CREDIT_REPORT_COMMENT,
  ClearableAnswerField.CURRENT_RESIDENCE,
  ClearableAnswerField.FIRST_NAME,
  ClearableAnswerField.IS_MOVE_IN_DATE_FLEXIBLE,
  ClearableAnswerField.IS_SMOKER,
  ClearableAnswerField.LAST_NAME,
  ClearableAnswerField.MIDDLE_NAME,
  ClearableAnswerField.MOVE_IN_DATE,
  ClearableAnswerField.OCCUPANTS,
  ClearableAnswerField.PETS,
  ClearableAnswerField.PHONE,
  ClearableAnswerField.REASON_FOR_MOVING,
] as const;
